import React from 'react';

const Picture = ({ imageSet, fallbackImage, title }) => (
  <picture>
    {imageSet.map(({ source, mediaQuery }, index) => (
      <source key={index} srcSet={source} media={mediaQuery} />
    ))}
    <img src={fallbackImage} alt={title} />
  </picture>
);

export default Picture;
